import RemindCustomerModule from './RemindCustomer.module';

export * from './RemindCustomerModuleProps';
export default RemindCustomerModule;
